import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    undoTimeout: Number,
    canRemoveMedia: Boolean
  }

  static targets = [
    'undoButton', 'removeButton'
  ]

  connect () {
    if (this.undoTimeoutValue > 0) {
      setTimeout(() => {
        if (this.hasUndoButtonTarget) {
          this.undoButtonTarget.remove()
        }

        if (this.canRemoveMediaValue) {
          this.removeButtonTarget.classList.remove('d-none')
        }
      }, this.undoTimeoutValue * 1000)
    }
  }

  download (event) {
    const url = event.currentTarget.getAttribute('href')
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = event.currentTarget.dataset.filename
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  }

  undo (event) {
    event.preventDefault(event)
    event.stopPropagation()
    this.dispatch('remove', { detail: { isUndo: true } })
  }

  remove (event) {
    event.preventDefault(event)
    event.stopPropagation()
    this.dispatch('remove')
  }
}
